var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.className,attrs:{"id":"back-box"}},[_c('div',{attrs:{"id":"back-to-top"},on:{"click":_vm.back}},[_c('svg-icon',{attrs:{"width":20,"height":20}},[_c('icon-back')],1)],1),_c('section',{staticClass:"back-shadow"})])}
var staticRenderFns = []

export { render, staticRenderFns }